export default __webpack_public_path__ + "static/geos-chem-6a374da0c076d927408c3af1ed6a8903.jpg";